import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      height: 'calc(100% - 80px)',
      overflowY: 'auto',
      paddingBlockEnd: 16,
    },

    lines: {
      listStyleType: 'none',
    },

    line: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      padding: [10, 0],
    },

    textContainer: {
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
    },

    text: {
      color: '#666',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '22px',
      marginInlineStart: 8,
    },

    bottomLinks: {
      listStyleType: 'none',
      marginBlockStart: 16,
    },

    bottomLinkContainer: {
      paddingBlock: 4,
      marginBlockEnd: 8,
    },

    bottomLink: {
      color: '#808080',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '32px',
    },
  },
  { name: 'NavBody' },
);
